import { Component } from 'react';
import classnames from 'classnames';
import { sendToGA } from '@/components/util';

export default class CustomReel extends Component<any, any> {
  reel: any;

  constructor(props: any) {
    super(props);
    this.state = {
      reelStep: -1,
      reel: [],
    };

    this.scrollHorizontally = this.scrollHorizontally.bind(this);
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.reel !== prevState.reel) {
      return {
        reelStep: -1,
        reel: nextProps.reel,
      };
    }
    return {};
  }

  scrollHorizontally(e: any) {
    if (this.reel) {
      e = window.event || e;
      const delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      this.reel.scrollLeft -= delta * 10; // Multiplied by 40
      e.preventDefault();
    }
  }

  componentDidMount() {
    if (this.reel) {
      this.reel.addEventListener('DOMMouseScroll', this.scrollHorizontally, false);
      this.reel.addEventListener('mousewheel', this.scrollHorizontally, false);
    }
  }

  public render() {
    const { reelStep, reel } = this.state;
    const { loadModel, tourId, isBlackBackground = true } = this.props;
    const filteredReel = reel.filter((r: any) => !r.hide);

    return (
      <div
        id="reel-bar"
        ref={(e: any) => {
          this.reel = e;
        }}
        className={classnames({ white: !isBlackBackground })}
      >
        <div className="scroll-div reels-block" style={{ width: `${170 * filteredReel.length}px` }}>
          {filteredReel.map((p: any, i: number) => (
            <div
              key={i}
              onClick={() => {
                if (p.url || p.tag || p.panoramaId) {
                  loadModel(
                    p.title,
                    p.url,
                    p.type,
                    p.tag,
                    p.panoramaId,
                    true,
                    false,
                    p.iframeSettings,
                  );
                  sendToGA('event', {
                    eventCategory: 'Highlight',
                    eventAction: 'click',
                    eventLabel: p.title,
                    eventId: p.id,
                  });
                }
                this.setState({ reelStep: i });
              }}
              className={reelStep === i ? 'preview active' : 'preview'}
              style={
                p.imageId
                  ? {
                      backgroundImage: `url(${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/images/${p.image.url})`,
                    }
                  : {}
              }
            >
              {p.type === 'matterport' ||
                p.type === 'matterport-instant' ||
                (p.type === 'treedis' && <i className="fas fa-walking" />)}
              <span>{p.title}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
